import { compose } from 'redux';
import { withRouter } from 'react-router-dom';

import { withContent } from 'components/Content';
import withLanding from 'containers/Landing/withLanding';
import { pages as PAGES } from 'containers/Landing/constants';
import PromotionLandingPage, {
  CONTENT_KEYS,
} from 'containers/Landing/PromotionLandingPage';

export default compose(
  withLanding(PAGES.mover50LandingPage),
  withContent(CONTENT_KEYS),
  withRouter,
)(PromotionLandingPage);
